import { CardType, CategoryType } from 'types/deck'

export function generateArenaText(cards: CardType[], categories: Record<string, CategoryType>): string {
  let deckString = ''
  let sideboardString = ''

  const generateLine = (card: CardType): string => {
    const code = card.mtgoCode.toUpperCase()
    return `${card.qty} ${card.name} (${code}) ${card.collectorNumber}\n`
  }

  cards.map(card => {
    const primaryCategory = categories[card.categories[0]]

    if (primaryCategory.name === 'Sideboard') sideboardString += generateLine(card)
    else if (primaryCategory.includedInDeck) deckString += generateLine(card)
  })

  deckString += '\n'
  deckString += sideboardString

  return deckString
}
